import React from 'react';
import Select from 'react-select';
import withTranslations from '../../../translations';

const SuperSelect = ({ options, gt, ...rest }) => (
  <Select
    {...rest}
    options={getOptions(options)}
    noOptionsMessage={() => gt.noOptions}
  />
)

function getOptions(options) {
  return (
    options
    ? options.map(option => {
        // If option is just a string, create minimal required object ({ value: option, label: option })
        if (typeof option === 'string') {
          return option = { 'value': option, 'label': option }
        }
        return option;
      })
    : []
  );
}

export default withTranslations(SuperSelect);



// WEBPACK FOOTER //
// ./src/components/base/SuperSelect/SuperSelect.js